import { Chip } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { green, grey, red } from "@mui/material/colors";
import { useTranslation } from "react-i18next";
import ColorUtil from "@plannel/pages/utils/color-util";
import { FONT } from "@plannel/components/ai/typographyTokens";
import { UC, statusLabel } from "./llmUsageUtil";

// 상태 대표색 - 표준 상태 칩(AuditTrail 의 auditOperationColor)과 같은 계열. 알 수 없는 상태는 중성 회색
const STATUS_COLOR = { ok: green[700], error: red[700] };
const NEUTRAL_COLOR = grey[600];

// 상태 칩 - 표준 틴트 칩 규격(tintChipSx)에서 테두리만 뺀 soft tint. 행 선택 배경에 묻히는 그리드는 bordered 로 테두리를 살린다
const StatusChip = ({ value, label, color: colorProp, bordered = false, fontSize = FONT.BODY, onClick }) => {
  const { t } = useTranslation();
  const color = colorProp || STATUS_COLOR[value] || NEUTRAL_COLOR;
  const clickable = !!onClick;
  return (
    <Chip size="small" label={label ?? statusLabel(t, value)} clickable={clickable} onClick={onClick}
      sx={{ height: 20, borderRadius: "6px", fontSize, "& .MuiChip-label": { px: "9px" },
        ...ColorUtil.tintChipSx(color),
        ...(bordered ? null : { border: "none" }),
        ...(clickable ? {
          "&:hover": { bgcolor: alpha(color, 0.22) },
          // 포커스 링은 이 화면 공통색 - 상태색으로 바꾸면 "상태가 변했다"로 읽힌다
          "&:focus-visible": { outline: `2px solid ${UC.acc}`, outlineOffset: 1 },
        } : null) }} />
  );
};

export default StatusChip;
